/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_BillingInputs */

const es_admin_company_overview_billing = /** @type {(inputs: Admin_Company_Overview_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación y uso`)
};

const en_admin_company_overview_billing = /** @type {(inputs: Admin_Company_Overview_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing & usage`)
};

/**
* | output |
* | --- |
* | "Billing & usage" |
*
* @param {Admin_Company_Overview_BillingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_billing = /** @type {((inputs?: Admin_Company_Overview_BillingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_BillingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_billing(inputs)
	return en_admin_company_overview_billing(inputs)
});
export { admin_company_overview_billing as "admin.company_overview.billing" }